module.exports = __webpack_public_path__ + "img/sc_back_default.b762b73f.png";